"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Video = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
exports.Video = (0, react_1.forwardRef)((props, ref) => {
    const videoEl = (0, react_1.useRef)(null);
    const { source, ...other } = props;
    (0, react_1.useImperativeHandle)(ref, () => videoEl.current); // it can't be null here
    (0, react_1.useEffect)(() => {
        const el = videoEl.current;
        if (el == null || source == null || el.srcObject === source) {
            return;
        }
        if (source instanceof MediaStream) {
            el.srcObject = source;
            el.play().catch((err) => {
                // ignore because it's probably already playing
            });
        }
        else {
            source.attachTo(el);
        }
    }, [source]);
    // eslint-disable-next-line jsx-a11y/media-has-caption
    return react_1.default.createElement("video", { ...other, ref: videoEl });
});
//# sourceMappingURL=Video.js.map